import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import DegreeManagement from 'app/containers/HumanResources/DegreeManagement'

const DegreeManagementPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.job_title_level_content_management)}</PageTitle>
      <DegreeManagement />
    </>
  )
}
const DegreeManagementPage = memo(DegreeManagementPageCpn, isEqual)

export default DegreeManagementPage
